"use strict";

var aminoAcidToDegenerateRnaMap = require("./aminoAcidToDegenerateRnaMap");

module.exports = function getDegenerateRnaStringFromAAString(aaString) {
  return aaString.split("").map(function (char) {
    return aminoAcidToDegenerateRnaMap[char.toLowerCase()] || "nnn";
  }).join("");
};